import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const LayoutWithGutter = styled(Box)({
  maxWidth: '632px',
  width: '100%',
  margin: '0 auto'
});
